import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const FlagOrdenCompraEnVentasFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagOrdenCompraEnVentas'>
      {({ field }) => (
        <Form.Checkbox {...field} checked={iValue} disabled={fIsSubmitting} id='checkbox-flagOrdenCompraEnVentas' label='O. de Compra en Ventas' />
      )}
    </Field>
  )
}

export default React.memo(FlagOrdenCompraEnVentasFormGroup)
